import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toast_error, toast_success } from "../../config/Constant";
import { setLoader } from "../../slice/commonSlice";
import {
  addCard,
  fetchAuthorizeCustomerProfile,
  fetchTipPlatformFee,
  giveTip,
} from "../../services/auth.service";
import { encryptData } from "../../utils/encryptDecrypt";
import { selectUser } from "../../slice/authSlice";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import * as cardValidator from "card-validator";

const TipModal = (props) => {
  const [amount, setAmount] = useState("");
  const [authorizeCustomerProfile, setAuthorizeCustomerProfile] = useState();
  const [cardNumber, setCardNumber] = useState("");
  // const [cardExpirationDate, setCardExpirationDate] = useState("");
  const [cardName, setCardName] = useState("");
  const [cardMonth, setCardMonth] = useState("");
  const [cardYear, setCardYear] = useState("");
  const [cvv, setCvv] = useState();
  const [selectedCardId, setSelectedCardId] = useState(null);
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [tipPlatformFee, setTipPlatformFee] = useState();
  const [calculatedFees, setCalculatedFees] = useState();
  const [errors, setErrors] = useState({
    cardNumber: "",
    cardYear: "",
    cardCvv: "",
  });

  const handleCardNumber = (value) => {
    value = value.replace(/\s/g, ""); // Remove existing spaces
    value = value.replace(/-/g, ""); // Remove existing dashes

    // Add space or dash after every four digits
    value = value.replace(/(\d{4})(?=\d)/g, "$1 ");

    // Trim extra characters if the length exceeds 19 digits (including spaces)
    value = value.slice(0, 23);
    setCardNumber(value);
  };

  const checkCard = () => {
    let valid = true;
    const cardNumberValidation = cardValidator.number(cardNumber);
    const expiryDateValidation = cardValidator.expirationDate({
      month: cardMonth,
      year: cardYear,
    });
    const cvvValidation = cardValidator.cvv(cvv);
    let newErros = { ...errors };
    if (!cardNumberValidation.isValid) {
      // alert('Invalid Card Number');
      valid = false;
      newErros.cardNumber = "Invalid card number";
      // return;
    } else {
      newErros.cardNumber = "";
    }

    if (!expiryDateValidation.isValid) {
      valid = false;
      newErros.cardYear = "Invalid card expiry date";
      // return;
    } else {
      newErros.cardYear = "";
    }

    if (!cvvValidation.isValid) {
      valid = false;
      newErros.cardCvv = "Invalid card number";
      // return;
    } else {
      newErros.cardCvv = "";
    }
    setErrors(newErros);
    return valid;
  };

  //get authorize customer profile
  const getAuthorizeCustomerProfile = async () => {
    let payload = {
      customerProfileId: user?.userCustomerProfileId,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchAuthorizeCustomerProfile(payload);
      await dispatch(setLoader(false));
      if (response.status) {
        setAuthorizeCustomerProfile(response?.data);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  //get authorize customer profile
  const getTipPlatformFee = async () => {
    await dispatch(setLoader(true));
    try {
      const response = await fetchTipPlatformFee();
      await dispatch(setLoader(false));
      if (response.status) {
        setTipPlatformFee(response?.data?.tipPlatformFee);
      }
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getAuthorizeCustomerProfile();
    getTipPlatformFee();
  }, []);

  const handleAddCard = async () => {
    if (checkCard()) {
      const payload = {
        // cardName,
        cardExpirationDate: encryptData(cardMonth + cardYear),
        cvv: encryptData(cvv),
        customerProfileId: user.userCustomerProfileId,
        cardNumber: encryptData(cardNumber.replace(/\s/g, "")),
      };
      await dispatch(setLoader(true));
      try {
        const response = await addCard(payload);
        await dispatch(setLoader(false));
        setCardMonth("");
        setCardNumber("");
        setCardYear("");
        setCardName("");
        setSelectedCardId(null);
        setCvv("");
        getAuthorizeCustomerProfile();
        if (response?.data?.status) {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        } else {
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        await dispatch(setLoader(false));
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedCardId) {
      toast.error("Please select credit card to proceed further");
    }
    let payload = {
      tip: Number(amount) + calculatedFees,
      userType: "user",
      jobId: props.job?._id,
      customerProfileId: user.userCustomerProfileId,
      paymentProfileId: selectedCardId,
      originalAmount: Number(amount),
    };
    await dispatch(setLoader(true));
    try {
      const response = await giveTip(payload);
      if (response.status) {
        if (response?.data?.status) {
          toast.success(response?.data?.message, toast_success);
          props.handleSuccessTip();
          props.setTipModal(false);
        } else {
          toast.error(response?.data?.message, toast_error);
          props.setTipModal(false);
        }
        await dispatch(setLoader(false));

      }
      await dispatch(setLoader(false));
    } catch (error) {
      toast.success(error?.data?.message, toast_error);
      await dispatch(setLoader(false));
    }
  };
  const handlePriceKeyPress = (e) => {
    const isValidInput = /^[0-9\b]*(\.\d{0,4})?$/.test(e.target.value + e.key);
    if (!isValidInput) {
      e.preventDefault();
    }
  };
  const calculatePlatformFees = (value) => {
    if (value) {
      let tipPlatform = value * (tipPlatformFee / 100);
      setCalculatedFees(tipPlatform);
    }
  };

  const handleChangeTip = (value) => {
    setAmount(value);
    calculatePlatformFees(value);
  };
  return (
    <>
      <Modal
        size="sm"
        show={props.tipModal}
        onHide={() => props.setTipModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="pt-0">
          <h2 className="modal-title text-center">Give Tip</h2>
          <Form
            className="modal-form-wrapper"
            onSubmit={(e) => handleSubmit(e)}
          >
            <Form.Group className="mb-4" controlId="describe">
              <Form.Label>Tip Amount ($)</Form.Label>
              <Form.Control
                type="text"
                value={amount}
                placeholder="Enter Tip Amount"
                name="tip"
                onChange={(e) => handleChangeTip(e.target.value)}
                onKeyPress={handlePriceKeyPress}
              />
            </Form.Group>
            {amount ? (
              <div>
                <p>Tip Amount: ${amount}</p>
                <p>Transaction fees: ${calculatedFees.toFixed(2)}</p>
                <p>
                  Final Tip Amount: $
                  {amount && (Number(amount) + calculatedFees).toFixed(2)}
                </p>
              </div>
            ) : null}
            <div className="account-info-wrap" id="manage-payment">
              <div className="account-info-title">
                Manage your payment methods
              </div>
              <div className="payment-method-wrapper">
                {authorizeCustomerProfile?.customerProfile?.profile
                  ?.paymentProfiles?.length ? (
                  authorizeCustomerProfile?.customerProfile?.profile?.paymentProfiles?.map(
                    (card, index) => (
                      <>
                        <div className="card-wrapper primary" key={index}>
                          <label htmlFor={`primary-${index}`}>
                            <div className="card-left">
                              <label className="card-title">
                                Click to select card
                              </label>
                              <input
                                className="radioInput"
                                type="radio"
                                name="primary"
                                id={`primary-${index}`}
                                checked={
                                  selectedCardId ===
                                  card.customerPaymentProfileId
                                }
                                onChange={() =>
                                  setSelectedCardId(
                                    card.customerPaymentProfileId
                                  )
                                }
                              />
                            </div>
                            <div className="card-right">
                              <div className="card-number">
                                XXXX XXXX{" "}
                                {card?.payment?.creditCard?.cardNumber}
                              </div>
                              <div className="card-logo">
                                {card?.payment?.creditCard?.cardType}
                              </div>
                            </div>
                          </label>
                        </div>
                        <div
                          className="add-new-card-row"
                          style={{ marginTop: "20px" }}
                        >
                          <div className="add-new-card"></div>
                        </div>
                      </>
                    )
                  )
                ) : (
                  <p>
                    You have not added any card yet, Please add card and select
                    card to proceed.
                  </p>
                )}

                <div className="add-new-card-form">
                  <div className="add-new-title">Add New Card</div>
                  <div className="add-new-card w-100">
                    <Row className="g-3">
                      <Col md={12}>
                        <Form.Label>Card Number</Form.Label>
                        <Form.Control
                          type="text"
                          value={cardNumber}
                          placeholder="Enter Card Number"
                          onChange={(e) => handleCardNumber(e.target.value)}
                        />
                        <div className="payment-error">
                          {errors?.cardNumber ? errors.cardNumber : null}
                        </div>
                      </Col>
                      <Col md={4}>
                        <Form.Label>Expiry Month</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          value={cardMonth}
                          onChange={(e) => setCardMonth(e.target.value)}
                        >
                          <option>Select Month</option>
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                          <option value="09">09</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                        </Form.Select>
                      </Col>
                      <Col md={4}>
                        <Form.Label>Expiry Year</Form.Label>
                        <Form.Control
                          type="text"
                          value={cardYear}
                          placeholder="Enter Expiry Year"
                          onChange={(e) => setCardYear(e.target.value)}
                        />
                        <div className="payment-error">
                          {errors?.cardYear ? errors.cardYear : null}
                        </div>
                      </Col>
                      <Col md={4}>
                        <Form.Label>CVV</Form.Label>
                        <Form.Control
                          type="text"
                          value={cvv}
                          placeholder="Enter CVV"
                          onChange={(e) => setCvv(e.target.value)}
                        />
                        <div className="payment-error">
                          {errors?.cardCvv ? errors.cardCvv : null}
                        </div>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-between mt-3 align-items-center">
                      <Button
                        variant="primary"
                        onClick={handleAddCard}
                        style={{ marginBottom: "20px" }}
                      >
                        Add Card
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Form.Group className="mb-4">
              <div className="d-grid">
                <Button
                  type="submit"
                  disabled={!amount || amount == 0}
                  variant="primary"
                  size="lg"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TipModal;
